// import React, { useEffect, useState } from 'react';
// import './Analysis.css';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar, } from "recharts";
// import { Restaurant } from '@mui/icons-material';
// import axios from 'axios';
// import StandardMenu from './StandardMenu';




// const StandardReport = () => {
//     const [orders, setOrders] = useState([]);
//     const [vendorId, setVendorId] = useState(null);
//     const [paymentData, setPaymentData] = useState([]);
//     const [weeklyData, setWeeklyData] = useState([]);
//     const isMobile = window.innerWidth <= 768;
//     const [orderCounts, setOrderCounts] = useState({
//         Food: 0,

//     });


//     useEffect(() => {
//         const fetchTodayOrders = async () => {
//             try {
//                 const token = localStorage.getItem("authToken"); // ✅ Get token
//                 if (!token) {
//                     console.error("Authorization token is missing");
//                     return;
//                 }

//                 const response = await axios.get(
//                     `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`, // ✅ Set token in header
//                         },
//                     }
//                 );
//                 const allOrders = response.data;

//                 const today = new Date().toISOString().split("T")[0];

//                 const counts = {
//                     Food: 0,

//                 };

//                 allOrders.forEach((order) => {
//                     const orderDate = new Date(order.orderDateAndTime).toISOString().split("T")[0];
//                     const appType = order.appType;
//                     const status = order.status;

//                     if (
//                         orderDate === today &&
//                         status === "COMPLETED" &&
//                         counts.hasOwnProperty(appType)
//                     ) {
//                         counts[appType]++;
//                     }
//                 });

//                 setOrderCounts(counts);
//             } catch (error) {
//                 console.error("Error fetching orders:", error);
//             }
//         };

//         if (vendorId) {
//             fetchTodayOrders();
//         }
//     }, [vendorId]);


//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         if (storedVendorId) {
//             setVendorId(storedVendorId);
//         }
//     }, []);

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const token = localStorage.getItem("authToken"); // ✅ Get token from local storage
//                 if (!token) {
//                     console.error("Authorization token is missing");
//                     return;
//                 }

//                 const res = await axios.get(
//                     `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`, // ✅ Add token to header
//                         },
//                     }
//                 );

//                 const orders = res.data;

//                 // Count each paymentMethod
//                 const methodCount = {};
//                 orders.forEach(order => {
//                     const method = order.paymentMethod || 'Unknown';
//                     methodCount[method] = (methodCount[method] || 0) + 1;
//                 });

//                 // Convert to pie chart format
//                 const total = orders.length;
//                 const chartData = Object.keys(methodCount).map(method => ({
//                     name: method,
//                     value: methodCount[method],
//                     percent: (methodCount[method] / total) * 1,
//                 }));

//                 setPaymentData(chartData);
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//             }
//         };

//         if (vendorId) {
//             fetchData();
//         }
//     }, [vendorId]); // << depend on vendorId
//     const COLORS1 = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#A28BFE'];
//     const [activeTab, setActiveTab] = useState('Overview');

//     const [monthlyData, setMonthlyData] = useState([]);

//     const topItems = [
//         { name: "Chicken", orders: 240 },
//         { name: "Paneer", orders: 180 },
//         { name: "Paneer Butter", orders: 170 },
//         { name: "Mutton", orders: 190 },
//         { name: "Fish", orders: 160 },
//         { name: "Veg meals", orders: 130 },

//     ];

//     ///==========Total orders============///


//     useEffect(() => {
//         const fetchWeeklyData = async () => {
//             try {
//                 const token = localStorage.getItem("authToken");
//                 if (!token) {
//                     console.error("Authorization token is missing");
//                     return;
//                 }

//                 const response = await axios.get(
//                     `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`,
//                         },
//                     }
//                 );

//                 const orders = response.data;

//                 const groupedData = {};

//                 orders.forEach((order) => {
//                     const date = new Date(order.orderDateAndTime);

//                     // Get the first day (Sunday) of the week
//                     const firstDayOfWeek = new Date(date);
//                     firstDayOfWeek.setDate(date.getDate() - date.getDay());
//                     firstDayOfWeek.setHours(0, 0, 0, 0); // Normalize time

//                     const weekKey = firstDayOfWeek.toISOString().split("T")[0]; // e.g., "2025-06-09"

//                     if (!groupedData[weekKey]) {
//                         groupedData[weekKey] = { week: weekKey, Orders: 0, Revenue: 0 };
//                     }

//                     groupedData[weekKey].Orders += 1;
//                     groupedData[weekKey].Revenue += order.totalAmount || 0;
//                 });

//                 // Convert object to array and sort by week
//                 const sortedData = Object.values(groupedData).sort((a, b) => {
//                     return new Date(a.week) - new Date(b.week);
//                 });

//                 setWeeklyData(sortedData); // You must have setWeeklyData defined in your component state
//             } catch (error) {
//                 console.error("Error fetching weekly data:", error);
//             }
//         };

//         if (vendorId) {
//             fetchWeeklyData();
//         }
//     }, [vendorId]);




//     //////=========================Revenue===================/////

//     const [revenueBreakdown, setRevenueBreakdown] = useState({
//         Food: 0,

//     });

//     useEffect(() => {
//         if (!vendorId) return;

//         const fetchTodayRevenue = async () => {
//             try {
//                 const response = await axios.get(
//                     `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`
//                 );

//                 const allOrders = response.data;
//                 const today = new Date().toISOString().split("T")[0];

//                 const todayOrders = allOrders.filter((order) =>
//                     order.orderDateAndTime?.startsWith(today)
//                 );

//                 const revenueByAppType = {
//                     Food: 0,

//                 };

//                 let total = 0;

//                 todayOrders.forEach((order) => {
//                     const appType = order.appType;
//                     const amount = order.totalAmount || 0;
//                     if (revenueByAppType.hasOwnProperty(appType)) {
//                         revenueByAppType[appType] += amount;
//                         total += amount;
//                     }
//                 });

//                 // Calculate percentage
//                 const percentageBreakdown = {};
//                 for (let key in revenueByAppType) {
//                     percentageBreakdown[key] = total
//                         ? ((revenueByAppType[key] / total) * 100).toFixed(1)
//                         : 0;
//                 }

//                 setRevenueBreakdown(percentageBreakdown);
//             } catch (error) {
//                 console.error("Error fetching today's revenue:", error);
//             }
//         };

//         fetchTodayRevenue();
//     }, [vendorId]);

//     //===================Total Customer===================//

//     const [customerCounts, setCustomerCounts] = useState({
//         Food: 0,

//     });

//     useEffect(() => {
//         if (!vendorId) return;

//         const fetchTodayCustomers = async () => {
//             try {
//                 const token = localStorage.getItem("authToken"); // ✅ Get token
//                 if (!token) {
//                     console.error("Authorization token is missing");
//                     return;
//                 }

//                 const response = await axios.get(
//                     `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`, // ✅ Include token in headers
//                         },
//                     }
//                 );

//                 const allOrders = response.data;
//                 const today = new Date().toISOString().split("T")[0];

//                 const todayOrders = allOrders.filter((order) => {
//                     const orderDate = new Date(order.orderDateAndTime)
//                         .toISOString()
//                         .split("T")[0];
//                     return orderDate === today;
//                 });

//                 const counts = {
//                     Food: 0,

//                 };

//                 todayOrders.forEach((order) => {
//                     const appType = order.appType;
//                     if (appType === "Food") counts.Food += 1;
//                     else if (appType === "Room") counts.Rooms += 1;
//                     else if (appType === "Banquet") counts.Banquet += 1;
//                     else if (appType === "Fashion") counts.Fashion += 1;
//                 });

//                 setCustomerCounts(counts);
//             } catch (error) {
//                 console.error("Error fetching today's customer data:", error);
//             }
//         };

//         fetchTodayCustomers();
//     }, [vendorId]);

//     //==============SALES AND REPORTS  Items===========//
//     const [data5, setData5] = useState([]);

//     useEffect(() => {
//         if (!vendorId) return;

//         const fetchOrders = async () => {
//             try {
//                 const token = localStorage.getItem("authToken"); // ✅ Get token
//                 if (!token) {
//                     console.error("Authorization token is missing");
//                     return;
//                 }

//                 const response = await axios.get(
//                     `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`, // ✅ Include token in headers
//                         },
//                     }
//                 );

//                 const completedOrders = response.data.filter(order => order.status === "COMPLETED");

//                 const dailyData = {};

//                 completedOrders.forEach(order => {
//                     const dateObj = new Date(order.orderDateAndTime);
//                     const weekday = dateObj.toLocaleDateString('en-US', { weekday: 'short' }); // "Mon", "Tue", etc.
//                     const appType = order.appType;

//                     if (!dailyData[weekday]) {
//                         dailyData[weekday] = { day: weekday, Food: 0, Rooms: 0, BanquetHalls: 0, Fashion: 0 };
//                     }

//                     if (dailyData[weekday][appType] !== undefined) {
//                         dailyData[weekday][appType] += 1;
//                     }
//                 });

//                 // Preserve weekday order: Mon → Sun
//                 const weekdayOrder = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
//                 const sortedData = weekdayOrder
//                     .filter(day => dailyData[day])
//                     .map(day => dailyData[day]);

//                 setData5(sortedData);
//             } catch (error) {
//                 console.error("Error fetching sales data:", error);
//             }
//         };

//         fetchOrders();
//     }, [vendorId]);


//     ////===========Recommendations===============//////////

//     const [recommendations, setRecommendations] = useState([]);

//     useEffect(() => {
//         if (!vendorId) return;

//         const fetchOrderData = async () => {
//             try {
//                 const response = await axios.get(
//                     `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`
//                 );
//                 const orders = response.data;

//                 generateRecommendations(orders);
//             } catch (error) {
//                 console.error("Error fetching order data:", error);
//             }
//         };

//         fetchOrderData();
//     }, [vendorId]);

//     const generateRecommendations = (orders) => {
//         const currentRecommendations = [];

//         // 📊 1. Peak Sales Between 7-9 PM
//         const eveningOrders = orders.filter(order => {
//             const orderHour = new Date(order.createdAt).getHours();
//             return orderHour >= 19 && orderHour <= 21;
//         });
//         const eveningRatio = (eveningOrders.length / orders.length) * 100;
//         if (eveningRatio > 30) {
//             currentRecommendations.push(
//                 '"Peak sales happen between 7-9PM. Consider discounts!"'
//             );
//         }

//         // 💳 2. Payment Preferences
//         const onlinePayments = orders.filter(order => order.paymentMode === "Online");
//         const onlinePaymentRatio = (onlinePayments.length / orders.length) * 100;
//         if (onlinePaymentRatio > 70) {
//             currentRecommendations.push(
//                 '"80% of Customers prefer online payments. Reduce COD options!"'
//             );
//         }

//         // ❗ 3. Refund Rate
//         const refundOrders = orders.filter(order => order.status === "Refunded");
//         const refundRate = (refundOrders.length / orders.length) * 100;
//         if (refundRate > 5) {
//             currentRecommendations.push(
//                 '"Refund Rate increased by 5%. Analyze refund reasons!"'
//             );
//         }

//         setRecommendations(currentRecommendations);
//     };

//     ///=========success rate=============/////

//     const [successRates, setSuccessRates] = useState({
//         Food: 0,

//     });

//     useEffect(() => {
//         const fetchOrders = async () => {
//             try {
//                 const token = localStorage.getItem("authToken"); // ✅ Get token
//                 if (!token) {
//                     console.error("Authorization token is missing");
//                     return;
//                 }

//                 const response = await axios.get(
//                     `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`, // ✅ Include token in headers
//                         },
//                     }
//                 );

//                 const orders = response.data;

//                 const today = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"

//                 const todayOrders = orders.filter(order => {
//                     const orderDate = new Date(order.orderDateAndTime).toISOString().split("T")[0];
//                     return orderDate === today;
//                 });

//                 const categories = ["Food",];
//                 const rates = {};

//                 categories.forEach((category) => {
//                     const categoryOrders = todayOrders.filter(order => order.appType === category);
//                     const total = categoryOrders.length;
//                     const successful = categoryOrders.filter(order => order.status === "COMPLETED").length;

//                     const rate = total > 0 ? (successful / total) * 100 : 0;
//                     rates[category] = rate.toFixed(1); // 1 decimal place
//                 });

//                 setSuccessRates(rates);
//             } catch (error) {
//                 console.error("Error fetching orders:", error);
//             }
//         };

//         if (vendorId) fetchOrders();
//     }, [vendorId]);

//     // {=======================overview===============================}
//     const tabContent = {
//     }



//     return (
//         <div
//             className="cardcolumn"
//             style={{
//                 overflowY: "auto",
//                 height: isMobile ? "750px" : "550px",
//                 marginTop: "30px",
//                 scrollbarWidth: "none",
//             }}
//         >
//             {/* Tab Buttons */}
//             <div className='cardcolumn' style={{ gap: '10px', display: 'flex', justifyContent: 'space-evenly' }}>
//                 {Object.keys(tabContent).map((label) => (
//                     <button
//                         key={label}
//                         onClick={() => setActiveTab(label)}
//                         style={{
//                             border: 'none',
//                             borderRadius: '10px',
//                             width: '100px',
//                             height: '40px',
//                             backgroundColor: activeTab === label ? '#b15cd6' : '#d9d9d9',
//                             color: '#000',
//                             fontWeight: 'bold',
//                             cursor: 'pointer',
//                             transition: 'background-color 0.3s ease',
//                         }}
//                     >
//                         {label}
//                     </button>
//                 ))}

//             </div>

//             {/* Tab Content */}
//             <div className='cardcolumn' style={{ marginTop: '-20px', padding: '20px', borderRadius: '8px', }}>
//                 <div>
//                     <div className="status-overview4">
//                         <div style={{ background: "gray", color: "#fff" }} className="status-card4">
//                             <h3 style={{ display: 'flex', justifyContent: "center" }}>Total Orders</h3>
//                             <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Food: {orderCounts.Food}</p>

//                         </div>
//                         <div style={{ background: "gray", color: "#fff" }} className="status-card4">
//                             <h3 style={{ display: "flex", justifyContent: "center" }}>Total Revenue</h3>
//                             {Object.entries(revenueBreakdown).map(([type, percent]) => (
//                                 <p
//                                     key={type}
//                                     style={{ fontWeight: "bold", display: "flex", justifyContent: "center" }}
//                                 >
//                                     {type}: {percent}%
//                                 </p>
//                             ))}
//                         </div>

//                         <div
//                             style={{ background: "gray", color: "#fff" }}
//                             className="status-card4"
//                         >
//                             <h3 style={{ display: "flex", justifyContent: "center" }}>
//                                 Total Customers
//                             </h3>
//                             <p style={{ fontWeight: "bold", display: "flex", justifyContent: "center" }}>
//                                 Food: {customerCounts.Food}
//                             </p>

//                         </div>

//                         <div className="status-overview4">
//                             <div style={{ background: "gray", color: "#fff" }} className="status-card4">
//                                 <h3 style={{ display: 'flex', justifyContent: "center" }}>Success rate</h3>
//                                 {Object.entries(successRates).map(([category, rate]) => (
//                                     <p
//                                         key={category}
//                                         style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}
//                                     >
//                                         {category}: {rate}%
//                                     </p>
//                                 ))}
//                             </div>

//                         </div>
//                     </div>


//                 </div>
//             </div>
//             <div>
//                 <div
//                     className="cardcolumn"
//                     style={{
//                         display: "flex",
//                         flexWrap: "wrap",
//                         justifyContent: "space-between",
//                         gap: "16px",
//                     }}
//                 >
//                     <div
//                         style={{
//                             padding: "16px",
//                             flex: "1 1 48%",
//                             minWidth: "300px",
//                             maxWidth: "48%",
//                         }}
//                     >
//                         <h2
//                             style={{
//                                 fontSize: "24px",
//                                 fontWeight: "bold",
//                                 color: "red",
//                                 marginBottom: "16px",
//                                 marginLeft: "50px",
//                             }}
//                         >
//                             Weekly Orders & Revenue
//                         </h2>
//                         <ResponsiveContainer width="100%" height={300}>
//                             <BarChart
//                                 data={weeklyData} // make sure you're using weeklyData here
//                                 margin={{ top: 10, right: 10, left: 0, bottom: 10 }}
//                             >
//                                 <CartesianGrid strokeDasharray="3 3" />
//                                 <XAxis dataKey="week" /> {/* key changed from 'month' to 'week' */}
//                                 <YAxis />
//                                 <Tooltip />
//                                 <Legend />
//                                 <Bar dataKey="Orders" fill="#1f77b4" />
//                                 <Bar dataKey="Revenue" fill="#d62728" />
//                             </BarChart>
//                         </ResponsiveContainer>

//                     </div>

//                     <div
//                         style={{
//                             padding: "16px",
//                             flex: "1 1 48%",
//                             minWidth: "300px",
//                             maxWidth: "48%",
//                         }}
//                     >
//                         <h2
//                             style={{
//                                 fontSize: "24px",
//                                 fontWeight: "bold",
//                                 color: "red",
//                                 marginBottom: "16px",
//                                 marginLeft: "50px",
//                             }}
//                         >
//                             Top 6 Selling Items
//                         </h2>
//                         <ResponsiveContainer width="100%" height={300}>
//                             <BarChart
//                                 data={topItems}
//                                 margin={{ top: 10, right: 10, left: 0, bottom: 10 }}
//                             >
//                                 <CartesianGrid strokeDasharray="2 2" />
//                                 <XAxis dataKey="name" />
//                                 <YAxis />
//                                 <Tooltip />
//                                 <Legend />
//                                 <Bar dataKey="orders" fill="#1f77b4" />
//                             </BarChart>
//                         </ResponsiveContainer>
//                     </div>
//                 </div>
//                 <div
//                     className="cardcolumn"
//                     style={{
//                         display: "flex",
//                         flexWrap: "wrap",
//                         justifyContent: "space-between",
//                         gap: "16px",
//                     }}
//                 >
//                     <div
//                         style={{
//                             padding: "16px",
//                             flex: "1 1 48%",
//                             minWidth: "300px",
//                             maxWidth: "48%",
//                         }}
//                     >
//                         <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "red", marginBottom: "16px", textAlign: "center" }}>
//                             Most Preferred Payment
//                         </h2>
//                         <ResponsiveContainer width="100%" height={300}>
//                             <PieChart>
//                                 <Pie
//                                     data={paymentData}
//                                     cx="52%"
//                                     cy="40%"
//                                     outerRadius={80}
//                                     fill="#8884d8"
//                                     dataKey="value"
//                                     label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
//                                 >
//                                     {paymentData.map((entry, index) => (
//                                         <Cell key={`cell-${index}`} fill={COLORS1[index % COLORS1.length]} />
//                                     ))}
//                                 </Pie>
//                                 <Tooltip />
//                                 <Legend />
//                             </PieChart>
//                         </ResponsiveContainer>
//                     </div>

//                     <div
//                         style={{
//                             padding: "16px",
//                             flex: "1 1 48%",
//                             minWidth: "300px",
//                             maxWidth: "48%",
//                         }}
//                     >
//                         <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "red", marginBottom: "16px", marginLeft: "50px" }}>Sales Growth Chart</h2>
//                         <ResponsiveContainer width="100%" height={300}>
//                             <LineChart data={data5} margin={{ top: 10, right: 10, left: -25, bottom: 10 }}>
//                                 <CartesianGrid strokeDasharray="3 3" />
//                                 <XAxis dataKey="day" />
//                                 <YAxis />
//                                 <Tooltip />
//                                 <Legend />
//                                 <Line type="monotone" dataKey="Food" stroke="#d62728" dot={{ r: 5 }} />
//                                 <Line type="monotone" dataKey="Rooms" stroke="#1f77b4" dot={{ r: 5 }} />
//                                 <Line type="monotone" dataKey="BanquetHalls" stroke="#000" dot={{ r: 5 }} />
//                                 <Line type="monotone" dataKey="Fashion" stroke="#3412ff" dot={{ r: 5 }} />
//                             </LineChart>
//                         </ResponsiveContainer>
//                     </div>
//                 </div>
//             </div>

//             <div style={{ marginLeft: "50px" }}>
//                 <h3 style={{ color: "red" }}>Recommendations</h3>
//                 {recommendations.length > 0 ? (
//                     recommendations.map((msg, index) => (
//                         <p key={index} style={{ fontWeight: "bold" }}>
//                             {msg}
//                         </p>
//                     ))
//                 ) : (
//                     <p style={{ fontWeight: "bold" }}>No specific recommendations for now.</p>
//                 )}
//             </div>



//         </div>
//     );
// };

// const tableHeaderStyle = {
//     padding: '12px',
//     border: '1px solid #ddd',
//     textAlign: 'center',
//     fontWeight: 'bold',
//     backgroundColor: '#b15cd6',
//     color: 'white',
// };

// const tableCellStyle = {
//     padding: '12px',
//     border: '1px solid #ddd',
//     textAlign: 'center',
// };

// const evenRowStyle = {
//     backgroundColor: '#f9f9f9',
// };

// const oddRowStyle = {
//     backgroundColor: '#fff',
// };
// const inputStyle = {
//     width: '100%',
//     border: 'none',
//     backgroundColor: 'transparent',
//     textAlign: 'center',
// };

// export default StandardReport;




import React, { useEffect, useState } from "react";
import "./Analysis.css";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
} from "recharts";
import axios from "axios";

const StandardReport = () => {
  const [vendorId, setVendorId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [recommendations, setRecommendations] = useState([]);

  const isMobile = window.innerWidth <= 768;
  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#A28BFE"];

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) setVendorId(storedVendorId);
  }, []);

  useEffect(() => {
    if (!vendorId) return;

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) return;

        const res = await axios.get(
          `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        setData(res.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching report:", err);
        setLoading(false);
      }
    };

    fetchData();
  }, [vendorId]);



  useEffect(() => {
    if (!vendorId) return;

    const fetchOrderData = async () => {
      try {
        const response = await axios.get(
          `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`
        );
        const orders = response.data;

        generateRecommendations(orders);
      } catch (error) {
        console.error("Error fetching order data:", error);
      }
    };

    fetchOrderData();
  }, [vendorId]);


  const generateRecommendations = (orders) => {
    const currentRecommendations = [];

    // 📊 1. Peak Sales Between 7-9 PM
    const eveningOrders = orders.filter(order => {
      const orderHour = new Date(order.createdAt).getHours();
      return orderHour >= 19 && orderHour <= 21;
    });
    const eveningRatio = (eveningOrders.length / orders.length) * 100;
    if (eveningRatio > 30) {
      currentRecommendations.push(
        '"Peak sales happen between 7-9PM. Consider discounts!"'
      );
    }

    // 💳 2. Payment Preferences
    const onlinePayments = orders.filter(order => order.paymentMode === "Online");
    const onlinePaymentRatio = (onlinePayments.length / orders.length) * 100;
    if (onlinePaymentRatio > 70) {
      currentRecommendations.push(
        '"80% of Customers prefer online payments. Reduce COD options!"'
      );
    }

    // ❗ 3. Refund Rate
    const refundOrders = orders.filter(order => order.status === "Refunded");
    const refundRate = (refundOrders.length / orders.length) * 100;
    if (refundRate > 5) {
      currentRecommendations.push(
        '"Refund Rate increased by 5%. Analyze refund reasons!"'
      );
    }

    setRecommendations(currentRecommendations);
  };

  if (loading) {
    return (
      <div
        style={{
          height: "500px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "24px",
          fontWeight: "bold",
        }}
      >
        Loading...
      </div>
    );
  }

  if (!data) {
    return <div>No Data Found</div>;
  }

  // ✅ Transform API response for charts
  const paymentData = data.paymentDistribution.map((p) => ({
    name: p.method,
    value: p.count,
    percent: parseFloat(p.percentage),
  }));

  const topItems = data.topSellingItems.map((item) => {
    const key = Object.keys(item)[0];
    return { name: key, orders: item[key] };
  });

  const monthlyData = [
    {
      month: "This Week",
      Orders: data.weeklyOrders,
      Revenue: data.weeklyRevenue,
    },
    {
      month: "Today",
      Orders: data.dailyOrders,
      Revenue: data.dailyRevenue,
    },
  ];





  return (
    <div
      className="cardcolumn"
      style={{
        overflowY: "auto",
        height: isMobile ? "700px" : "550px",
        marginTop: "30px",
        scrollbarWidth: "none",
      }}
    >
      {/* Status Cards */}
      <div className="status-overview4">
        <div style={{ background: "gray", color: "#fff" }} className="status-card4">
          <h3>Total Orders</h3>
          <p>{data.totalOrders}</p>
        </div>
        <div style={{ background: "gray", color: "#fff" }} className="status-card4">
          <h3>Total Revenue</h3>
          <p>₹{data.totalRevenue}</p>
        </div>
        <div style={{ background: "gray", color: "#fff" }} className="status-card4">
          <h3>Total Customers</h3>
          <p>{data.totalCustomers}</p>
        </div>
        <div style={{ background: "gray", color: "#fff" }} className="status-card4">
          <h3>Success Rate</h3>
          <p>{data.successRate}</p>
        </div>
      </div>

      {/* Charts */}
      <div
        className="cardcolumn"
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: "16px",
          marginTop: "20px",
        }}
      >
        {/* Orders & Revenue */}
        <div style={{ padding: "16px", flex: "1 1 48%", minWidth: "300px" }}>
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "red",
              marginBottom: "16px",
            }}
          >
            Orders & Revenue
          </h2>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={monthlyData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="Orders" fill="#1f77b4" />
              <Bar dataKey="Revenue" fill="#d62728" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Top Selling Items */}
        <div style={{ padding: "16px", flex: "1 1 48%", minWidth: "300px" }}>
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "red",
              marginBottom: "16px",
            }}
          >
            Top Selling Items
          </h2>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={topItems}>
              <CartesianGrid strokeDasharray="2 2" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="orders" fill="#1f77b4" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Payment Distribution */}
      <div style={{ padding: "16px", textAlign: "center" }}>
        <h2
          style={{
            fontSize: "20px",
            fontWeight: "bold",
            color: "red",
            marginBottom: "16px",
          }}
        >
          Payment Distribution
        </h2>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={paymentData}
              cx="50%"
              cy="50%"
              outerRadius={100}
              dataKey="value"
              label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
            >
              {paymentData.map((entry, index) => (
                <Cell key={index} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div style={{ marginLeft: "50px" }}>
        <h3 style={{ color: "red" }}>Recommendations</h3>
        {recommendations.length > 0 ? (
          recommendations.map((msg, index) => (
            <p key={index} style={{ fontWeight: "bold" }}>
              {msg}
            </p>
          ))
        ) : (
          <p style={{ fontWeight: "bold" }}>No specific recommendations for now.</p>
        )}
      </div>
    </div>




  );
};

export default StandardReport;

